import React, { useState, useEffect, useRef } from 'react';

const Dropdown = ({
  options,
  selectedOption,
  onSelect,
  text,
  disabled,
  onSearch,
  onDropdownToggle,
  widthClass,
}) => {
  const localRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    if (!disabled) {
      const newState = !isOpen;
      setIsOpen(newState);
      onDropdownToggle && onDropdownToggle(newState);
    }
  };

  const handleSelect = (option) => {
    onSelect(option);
    setIsOpen(false);
    onDropdownToggle && onDropdownToggle(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (localRef.current && !localRef.current.contains(event.target)) {
        setIsOpen(false);
        onSearch && onSearch('');
        onDropdownToggle && onDropdownToggle(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onDropdownToggle, onSearch]);

  const containerClasses = widthClass || 'w-full';

  return (
    <div className={`relative text-left ${containerClasses}`} ref={localRef}>
      <button
        type="button"
        onClick={handleToggle}
        disabled={disabled}
        className={`
          bg-white
          border
          border-gray-300
          rounded-[6px]
          px-4
          py-2
          mt-1
          text-gray-400
          flex
          items-center
          justify-between
          w-full
          whitespace-nowrap
          overflow-hidden
          text-ellipsis
          ${disabled ? 'opacity-40 cursor-not-allowed' : ''}
        `}
      >
        <span className="truncate">{selectedOption || text}</span>
        <svg
          className="w-5 h-5 ml-2 flex-shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute left-0 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-md z-50 max-h-60 overflow-y-auto">
          {onSearch && (
            <div className="p-2">
              <input
                type="text"
                placeholder="Search..."
                className="w-full px-3 py-2 border rounded-md"
                onChange={(e) => onSearch(e.target.value)}
              />
            </div>
          )}
          <ul className="py-1">
            {options.map((option, index) => (
              <li
                key={index}
                onClick={() => handleSelect(option)}
                className="
                  px-4
                  py-2
                  text-gray-700
                  hover:bg-gray-100
                  flex
                  justify-between
                  items-center
                  cursor-pointer
                  whitespace-nowrap
                "
              >
                <span className="block truncate">{option.label || option}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
